import * as React from 'react';
import ApplicationBasicProfile, { Props } from './ApplicationBasicProfile';
import { shallow, ShallowWrapper } from 'enzyme';
import applicationDummy from '__fixtures__/application_dummy';

const createTestProps = moreProps => {
  return {
    cvUrl: '',
    application: applicationDummy,
    profileUrl: '',
    waitingForReview: true,
    ...moreProps,
  };
};

let props: Props;
let wrapped: ShallowWrapper;

describe('Application Basic Profile component', () => {
  beforeEach(() => {
    props = createTestProps({});
    wrapped = shallow(<ApplicationBasicProfile {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
